<!--ukey补办-->
<template>
  <div v-loading="loading" class="payment-account-user">
    <div class="module">
      <h5 class="module-title">Ukey补办</h5>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              label="补办Ukey用户："
              prop="userId"
              :rules="rules.userId"
              label-width="120px"
            >
              <el-radio-group v-model="ruleForm.userId">
                <el-radio
                  v-for="item in userList"
                  :key="item.userId"
                  :label="item.userId"
                  >{{ item.realName }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--      申请人信息-->
    <applicant-info ref="applicantInfo"></applicant-info>
    <!--      ukey收件人信息-->
    <ukey-recipient-info ref="ukeyRecipientInfo"></ukey-recipient-info>
    <div style="margin-top: 20px" class="footer-button">
      <eui-btn type="secondary" @click="handleReturn">返 回</eui-btn>
      <div>
        <eui-btn type="weak" @click="handleReturn">取 消</eui-btn>
        <eui-btn type="primary" @click="handleSubmit">提 交</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import bus from '@/components/common/bus';
import _ from 'lodash';
import ApplicantInfo from './applicantInfo';
import UkeyRecipientInfo from './ukeyRecipientInfo';

export default {
  name: 'AddUser',
  components: { ApplicantInfo, UkeyRecipientInfo },
  mixins: [],
  data() {
    return {
      loading: false,
      ruleForm: {
        userId: '',
        isDelAddSign: false,
      },
      rules: {
        userId: [{ required: true, message: '请选择用户', trigger: 'change' }],
      },
      userList: [],
    };
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const res = await Api.getAccountValidUserList();
      if (res.code === '200') {
        this.userList = res.data;
      }
    },
    // 提交
    async handleSubmit() {
      const formName = ['applicantInfo', 'ukeyRecipientInfo'];
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (!this.$refs[item]?.$refs.ruleForm) {
            reject();
          }
          this.$refs[item].$refs.ruleForm.validate((valid) => {
            if (valid) {
              resolve();
            }
          });
        });
      };
      const userForm = new Promise((resolve) => {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            resolve();
          }
        });
      });
      Promise.all([userForm, ...formName.map((item) => validates(item))]).then(
        () => {
          this.handleSave();
        }
      );
    },
    // 保存
    async handleSave() {
      const params = {
        accountUserUkeyTempAO: { ...this.$refs.ukeyRecipientInfo.ruleForm },
        ..._.cloneDeep(this.$refs.applicantInfo.ruleForm),
        ...this.ruleForm,
      };
      params.accountUserApplicantAttachAOList.forEach((item, index) => {
        // console.log(item);
        // 申请人证件
        if (item.attachType === 'AC') {
          item.certificateValidityBegin = item.certificateTimeRange?.[0];
          item.certificateValidityEnd = item.certificateTimeRange?.[1];
          delete item.certificateTimeRange;
          item.isLongTernEffective = item.isLongTernEffective ? 1 : 0;
          this.$set(params.accountUserApplicantAttachAOList, index, item);
        }
      });
      if (params.accountUserUkeyTempAO.provinceId) {
        params.accountUserUkeyTempAO.province =
          this.$refs.ukeyRecipientInfo.provinceList.find(
            (item) => item.areaId === params.accountUserUkeyTempAO.provinceId
          )?.areaName;
      }
      if (params.accountUserUkeyTempAO.cityId) {
        params.accountUserUkeyTempAO.city =
          this.$refs.ukeyRecipientInfo.cityList.find(
            (item) => item.areaId === params.accountUserUkeyTempAO.cityId
          )?.areaName;
      }
      if (params.accountUserUkeyTempAO.districtId) {
        params.accountUserUkeyTempAO.district =
          this.$refs.ukeyRecipientInfo.districtList.find(
            (item) => item.areaId === params.accountUserUkeyTempAO.districtId
          )?.areaName;
      }
      console.log(params, 'params');
      // 提交时，需要取支付平台查询用户状态，校验是否有未完成的续签申请
      const res = await Api.reissueUkeyCheckNotFinishCredentials({
        userId: this.ruleForm.userId,
      });
      if (res.code === '200') {
        params.isDelAddSign = res.data.status;
        if (res.data.status) {
          this.$confirm(
            '您补办UK的用户存在未完成的续签操作，取消续签后方可补办UK，是否取消续签？',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          )
            .then(() => {
              this.confirmSubmit(params);
            })
            .catch(() => {
              this.$message({
                type: 'warning',
                message: '证书存在未完成的续签操作，无法补办UKey',
              });
            });
        } else {
          this.confirmSubmit(params);
        }
      }
    },
    confirmSubmit(params) {
      Api.reissueUkeyEpayAccountUser(params).then((res) => {
        if (res.code === '200') {
          this.$message.success('提交成功');
          this.handleReturn();
        }
      });
    },
    handleReturn() {
      bus.$emit('close_current_tags');
      this.$router.replace('/paymentAccount');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/common.scss';
</style>
